module.exports = __webpack_public_path__ + "Wireframes7.png?701c89171ee7dce6e2c25a52f3d31348";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes7.png
// module id = 121
// module chunks = 0